import type { PayloadAction } from "@reduxjs/toolkit";

export const showAlertMessageReducer = (state: any, action: PayloadAction<any>) => {
    state.alertMessage = action.payload.alertMessage;
    state.showAlert = true;
    state.alertType = action.payload.alertType;
}

export const hideAlertMessageReducer = (state: any) => {
    state.alertMessage = '';
    state.showAlert = false;
    state.alertType = ''
}